'use client';
import styled from 'styled-components';

export const Trigger = styled.div.attrs({
  tabIndex: 0,
})`
  width: 16px;
  height: ${({ height }) => (height ? '16px' : 'unset')};
`;
